'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollFade = void 0;
var $ = require("jquery");
var ScrollFade = /** @class */ (function () {
    function ScrollFade() {
        $(window).scroll(function () {
            $('.trigScrollDisplay').each(function () {
                var position = $(this).offset().top;
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > position - windowHeight) {
                    $('.bulletScrollDisplay').attr('data-scroll', 1);
                    if ($('.paramHamburger').attr('data-open') === '0') {
                        $('.bulletScrollDisplay').css('display', 'none');
                    }
                }
                else {
                    $('.bulletScrollDisplay').attr('data-scroll', 0);
                    if ($('.paramHamburger').attr('data-open') === '0') {
                        $('.bulletScrollDisplay').css('display', 'block');
                    }
                }
            });
        });
    }
    return ScrollFade;
}());
exports.ScrollFade = ScrollFade;
exports.default = ScrollFade;
